
import Checkbox from '@/components/Folders/Checkbox'
export default {
    name: 'FilesystemSort',
    components: { Checkbox },
    data () {
        return {
            selectAll: false,
            params: {
                sort_by: undefined,
                sort_as: undefined
            }
        }
    },
    computed: {
        cleared () {
            return this.$store.getters['folders/selectedNodes'].length === 0
        }
    },
    watch: {
        selectAll (value) {
            this.$emit('select-all', value)
        },
        cleared (value) {
            if (value) {
                this.selectAll = false
            }
        }
    },
    mounted () {
        this.params.sort_by = this.$route.query.sort_by
        this.params.sort_as = this.$route.query.sort_as
    },
    methods: {
        sync (by) {
            this.params.sort_by = by

            if (this.params.sort_as === undefined) {
                this.params.sort_as = 'desc'
            } else if (this.params.sort_as === 'asc') {
                this.params.sort_as = 'desc'
            } else if (this.params.sort_as === 'desc') {
                this.params.sort_as = 'asc'
            }

            this.$emit('sort', this.params)
        }
    }
}
